import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot,RouterStateSnapshot,CanActivate,Router,ActivatedRoute,Route} from '@angular/router';
import { AuthService } from 'src/service/auth';
import {BasicService} from 'src/service/basic.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class AuthGuardService implements CanActivate {
	constructor(private router: Router,private authService: AuthService,private route: ActivatedRoute,private basicService:BasicService) { 
    }
  	canActivate(next: ActivatedRouteSnapshot,state: RouterStateSnapshot) { 
		try{
            
			if(this.basicService.getItem("user_data") && this.basicService.getItem("user_data")!="undefined" && this.basicService.getItem("user_data")!=""){
				let credential=this.basicService.getItem("user_data") as any;
				let data={email:credential.email,password:credential.password}
                return this.login(data).pipe(map(res=>{
					if(!res){
						this.router.navigateByUrl('/login');
						return false;
					}
					return true;
				}));
			}else{
				this.router.navigateByUrl('login');
				return false;
			}
		}catch(e){
			console.log(e);
			this.router.navigateByUrl('login');
			return false;
		}
  	}
  	login=(data:any)=>{
		return Observable.create((observer:any) => { 
            this.authService.check_login(data).toPromise().then((response: any) => {
                if(response.status === "success"){
                    this.basicService.user_data=response.user_data
                    this.basicService.user_data.password=data.password
                    this.basicService.setItem("user_data",this.basicService.user_data);
                    return observer.next(true);
                } else{
                    this.router.navigateByUrl('/login');
                    return observer.next(false);
                }
            });
		});
	}

}